export const HasCalculatorMixin = {
  static: {
    animationSpeed: 200 // The higher it is, the longer it takes
  },
  methods: {
    animateAmount(animatedAmountObject = {}) {
      if (animatedAmountObject.estimatedAmount >= animatedAmountObject.target) {
        animatedAmountObject.estimatedAmount = animatedAmountObject.target;

        return;
      }

      const increment = animatedAmountObject.target / this.animationSpeed;
      animatedAmountObject.estimatedAmount = Math.ceil(
        animatedAmountObject.estimatedAmount + increment
      );
      setTimeout(() => this.animateAmount(animatedAmountObject), 1);
    },
    scrollToCalculator() {
      this.$refs.calculator?.scrollIntoView({ behavior: 'smooth' });
    }
  }
};
